<template>
  <div class="page px-5">
    <page-layout>
      <h3
        slot="header"
        class="my-4 text-truncate"
      >
        <span class="d-none d-lg-inline">Manage</span>&nbsp;Tenants
      </h3>
      <b-button
        slot="header"
        size="sm"
        variant="primary"
        @click="addTenant()"
      >
        <i class="fa fa-plus" />
        <span class="d-none d-lg-inline-block">&nbsp; ADD TENANT</span>
      </b-button>
      <tenant-list />
    </page-layout>
  </div>
</template>

<script>
import PageLayout from "@/components/shared/PageLayout.vue";
import TenantList from "@/components/tenants/TenantList.vue";

export default {
  name: "Tenants",
  components: {
    PageLayout,
    TenantList,
  },
  methods: {
    addTenant() {
      this.$router.push({ path: `tenants/new` });
    },
  },
};
</script>